import React from 'react';

import { useEffect, useRef } from 'react';
import { useState } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AuthorStore from '../../../stores/AuthorStore';

const AuthorEditPage = ({ users }) => {
    const navigate = useNavigate();

    const store = AuthorStore((state) => state);

    const [isImageListVisible, setIsImageListVisible] = useState(false);

    const { authorId } = useParams();
    const fileInput = useRef(null);

    useEffect(() => {
        store.load(authorId);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.author) {
        return <div>Loading ...</div>;
    }

    const getFormInputComponent = function (author, attributeName) {
        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={author.id}
                        />
                    </FormGroup>
                );

            case 'firstName':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            First Name<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={author.firstName}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'firstName',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'lastName':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Last Name<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={author.lastName}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'lastName',
                                    e.target.value,
                                );
                            }}
                        />
                    </FormGroup>
                );

            case 'authorPhoto':
                return (
                    <FormGroup
                        style={{ marginTop: '8px' }}
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>Author's photo</FormLabel>
                        <FormControl
                            type="url"
                            placeholder="Enter image URL here..."
                            value={author.authorPhoto || ''}
                            onChange={(e) => {
                                store.updateAttribute(
                                    'authorPhoto',
                                    e.target.value,
                                );
                            }}
                        />
                        {author.authorPhoto ? (
                            <div
                                style={{
                                    marginTop: '10px',
                                    width: '150px',
                                    height: '150px',
                                    overflow: 'hidden',
                                    border: '1px solid #ccc',
                                }}
                            >
                                <img
                                    src={author.authorPhoto}
                                    alt="Author Photo Preview"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        ) : null}
                    </FormGroup>
                );

            default:
                return null;
        }
    };

    var formInputElements = [];

    formInputElements.push(getFormInputComponent(store.author, 'id'));
    formInputElements.push(getFormInputComponent(store.author, 'firstName'));
    formInputElements.push(getFormInputComponent(store.author, 'lastName'));
    formInputElements.push(getFormInputComponent(store.author, 'authorPhoto'));

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <ToastContainer autoClose={2000} position="top-center" />

            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/author/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>Author Edit Page</div>
                    <br />
                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                navigate('/author');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.save(
                                    store.author,
                                    () => {
                                        alert('Your edits were saved');
                                        navigate('/author');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.author.id,
                                    () => {
                                        alert('The author was deleted');
                                        navigate('/author');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>
                        <div>
                            <hr
                                style={{
                                    marginTop: '30px',
                                    backgroundColor: 'black',
                                    height: '15px',
                                }}
                            />
                        </div>
                        {buildImagesPanel()}
                    </form>
                </Col>
            </Row>
        </Container>
    );

    function buildImagesPanel() {
        let collection = isImageListVisible ? store.availableImages : [];

        return (
            <>
                <FormLabel style={{ fontSize: '2em', fontWeight: 'bold' }}>
                    Images
                </FormLabel>

                <Alert
                    key={'secondary'}
                    variant={'secondary'}
                    style={{ textAlign: 'right' }}
                >
                    <Button
                        style={{ marginLeft: '15px' }}
                        onClick={() => {
                            setIsImageListVisible(!isImageListVisible);

                            store.listAvailableImages(
                                store.author.id,
                                () => {},
                                () => {},
                            );
                        }}
                    >
                        {isImageListVisible ? 'Hide' : 'Show'} Available Images
                    </Button>

                    {!isImageListVisible
                        ? null
                        : buildAvailableFilesPanel(
                              isImageListVisible,
                              collection,
                          )}
                </Alert>
            </>
        );
    }
    function buildAvailableFilesPanel(isImageListVisible, collection) {
        let fileType = isImageListVisible ? 'image' : 'pdf';
        let fileTypeHumanReadable =
            fileType[0].toUpperCase() + fileType.substring(1, fileType.length);

        return (
            <div
                style={{
                    marginTop: '30px',
                    backgroundColor: '#f3f3f1',
                    padding: '10px',
                }}
            >
                <h3>Available {fileTypeHumanReadable + 's'}</h3>

                <ul style={{ listStyle: 'number' }}>
                    {null == collection
                        ? null
                        : collection.map((filename, i) => {
                              var url =
                                  window.location.origin +
                                  '/img-u/authors/' +
                                  store.author.id +
                                  '/' +
                                  filename;

                              return (
                                  <li style={{ marginTop: '8px' }}>
                                      {url}

                                      <Button
                                          style={{ marginLeft: '15px' }}
                                          onClick={() => {
                                              navigator.clipboard.writeText(
                                                  url,
                                              );
                                              toast('URL copied to clipboard');
                                          }}
                                      >
                                          Copy
                                      </Button>

                                      <Button
                                          style={{ marginLeft: '15px' }}
                                          onClick={() => {
                                              store.deleteFile(
                                                  store.author.id,
                                                  filename,
                                              );
                                          }}
                                      >
                                          Remove
                                      </Button>
                                  </li>
                              );
                          })}
                </ul>

                <div style={{ marginTop: '10px' }}></div>

                <hr />

                <h5>Upload New {fileTypeHumanReadable}</h5>

                <FormControl
                    type="file"
                    style={{ marginLeft: '15px', float: 'right' }}
                    filename={store.fileForUpload}
                    ref={fileInput}
                    onChange={(e) => {
                        store.setFileForUpload(e.target.files[0]);
                    }}
                />

                <Button
                    style={{ marginTop: '15px' }}
                    disabled={null == store.fileForUpload}
                    onClick={() => {
                        var file = store.fileForUpload;
                        store.uploadFile(
                            store.author.id,
                            file,
                            fileType,
                            () => {
                                // Reset file input widget
                                fileInput.current.value = '';
                                fileInput.current.type = 'text';
                                fileInput.current.type = 'file';

                                alert('Upload successful!');
                            },
                            () => {
                                alert('Something went wrong with the upload!');
                            },
                        );
                    }}
                >
                    Upload
                </Button>
            </div>
        );
    }
};

export default AuthorEditPage;
